import React, { useState, useRef, useEffect } from "react";
import Styles from "../../../assets/css/Blogs/PerfectGiftsGuide/MuscleMassager.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const MuscleMassager = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const MuscleMassager = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/PerfectGiftsGuide/MuscleMassager/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./16.avif"),
    ProductImages("./18.avif"),
    ProductImages("./27.avif"),
    ProductImages("./28.avif"),
    ProductImages("./32.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (MuscleMassager.current) {
        const { width, height } =
          MuscleMassager.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    // Placeholder for position absoluted div that helps accupy the space of absoluted positioned div
    <>
      <Helmet>
        {/* Title Tag: Displayed in browser tabs and search results */}
        <title>Muscle Massager – Best Gift for Fitness Fans 💪</title>

        {/* Meta Description: A concise summary for search engines */}
        <meta
          name="description"
          content="Deep muscle relief with this portable massager. Ideal for athletes, gym-goers, and relaxation seekers."
        />

        {/* Meta Keywords: Helps with search engine indexing (use sparingly) */}
        <meta
          name="keywords"
          content="muscle massager, fitness gift, massage gun, deep tissue massage, portable massager, recovery tool"
        />

        {/* Viewport: Ensures proper scaling on mobile devices */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags: Enhance social media sharing */}
        <meta
          property="og:title"
          content="Muscle Massager – Best Gift for Fitness Fans 💪"
        />
        <meta
          property="og:description"
          content="Deep muscle relief with this portable massager. Ideal for athletes, gym-goers, and relaxation seekers."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/PerfectGiftsGuide/musclemassager"
        />
        {/* <meta property="og:image" content="/images/MuscleMassager/16.png" /> */}

        {/* Twitter Card Tags: Enhance Twitter sharing with a large summary image */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Muscle Massager – Best Gift for Fitness Fans 💪"
        />
        <meta
          name="twitter:description"
          content="Deep muscle relief with this portable massager. Ideal for athletes, gym-goers, and relaxation seekers."
        />
        {/* <meta name="twitter:image" content="/images/MuscleMassager/16.png" /> */}

        {/* Robots Tag: Instructs search engines to index this page and follow its links */}
        <meta name="robots" content="index, follow" />

        {/* Canonical Link: Prevents duplicate content issues by specifying the preferred URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/PerfectGiftsGuide/musclemassager"
        /> */}

        {/* Additional SEO Optimization */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div ref={MuscleMassager} className={Styles.MuscleMassagerContainer}>
        <section className={Styles.MuscleMassagerSection1}>
          <div className={Styles.MuscleMassagerSection1Text1Container}>
            {/* <h1>Powerful Compact Spotlight for Every Adventure 🌟</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[0]}`}
            alt="Foot Muscle Massager"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.MuscleMassagerSection1Text2Container}>
            <h1>| Foot Muscle Massager |</h1>
            <h1>The Perfect Gift for Relaxation & Wellness 🎁✨</h1>
            <p>
              Finding a meaningful gift that offers both comfort and health
              benefits can be challenging. A high-quality foot circulation
              massager is a thoughtful choice for any occasion. Whether for a
              birthday, anniversary, or just because, this wellness essential
              helps relieve tension, improve circulation, and promote relaxation
              effortlessly.
            </p>
          </div>
          <div className={Styles.MuscleMassagerSection1Img2Container}>
            <img
              src={`${ProductImagesArray[4]}`}
              alt="Foot Muscle Massager"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Foot Muscle Massager"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.MuscleMassagerSection1Text3Container}>
            <h1>Health & Wellness Benefits</h1>
            <p>
              <span style={{ color: "black" }}>Boosts Circulation </span> ✅
              Supports healthy blood flow, reducing discomfort in feet and legs.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Advanced Stimulation Technology
              </span>{" "}
              ✅ Uses innovative techniques for deep relaxation and recovery.
            </p>
            <p>
              <span style={{ color: "black" }}>Customizable Comfort</span> ✅
              Adjustable settings ensure a personalized experience for every
              user.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Long-Term Wellness Investment
              </span>{" "}
              ✅ Encourages self-care and relaxation, enhancing overall
              well-being.
            </p>
          </div>
          <div className={Styles.MuscleMassagerSection1Img3Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Foot Muscle Massager"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Foot Muscle Massager"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.MuscleMassagerSection1Text4Container}>
            <h1>A Versatile Choice for Everyone</h1>
            <p>
              Perfect for fitness enthusiasts, seniors, or anyone dealing with
              daily fatigue, this foot massager is a practical and appreciated
              gift. Designed with premium materials and safety in mind, it meets
              high-quality standards, making it a reliable and durable option
              for long-term use. When selecting a wellness product, always
              choose one that aligns with industry standards and trusted
              sources. A well-chosen massager provides both relaxation and
              health benefits, making it a valuable addition to any home.
            </p>
          </div>
          <div className={Styles.MuscleMassagerSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/4jWcExh"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.MuscleMassagerSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.MuscleMassagerSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.MuscleMassagerSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #FootMassager #WellnessGift #Relaxation #CirculationBooster
              #PainRelief #ThoughtfulGift #EMSFootMassager #TENSFootMassager
              #MuscleRecovery #SelfCare #HealthTech #GiftIdeas #MassageTherapy
              #HomeRelaxation #NeuropathyRelief
            </p>
            <h1>Keywords</h1>
            <p>
              Relax tired feet with a soothing foot circulation massager.
              Improve blood flow and reduce discomfort with advanced stimulation
              technology. Relieve muscle tension after long hours of standing or
              walking. Perfect for seniors and those seeking foot pain relief. A
              thoughtful self-care gift for relaxation and wellness. Deep
              relaxation at home with adjustable massage settings. Best foot
              massager for neuropathy and circulation support.
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default MuscleMassager;
